import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";


import Login from "../screens/login/LoginMain";
// import PasswordRecovery from "../screens/login/LoginPasswordRecovery";
import Restaurants from "../screens/Restaurants"
import AddEditRestaurant from "../screens/restaurants/AddEditRestaurant"
import AddEditTicketType from "../screens/restaurants/AddEditTicketType"
import AddEditTicket from "../screens/restaurants/AddEditTicket"
import AddEditMenuCategory from "../screens/restaurants/AddEditMenuCategory"
import Statistics from "../screens/restaurants/Statistics"
import StatisticsRRPP from "../screens/restaurants/StatisticsRRPP"
import TicketTypes from "../screens/restaurants/TicketTypes"
import MenuCategories from "../screens/restaurants/MenuCategories"
import Tickets from "../screens/restaurants/Tickets"
import Reservations from "../screens/restaurants/Reservations"
import Users from "../screens/Users"
import DeliveryBoys from "../screens/DeliveryBoys"
import Places from "../screens/Places"
import Notifications from "../screens/Notifications"
import AddEditNotifications from "../screens/notifications/AddEditNotifications"
import News from "../screens/News"
import AddEditNovelty from "../screens/news/AddEditNovelty"
import DDJJ from "../screens/DDJJ"
import Home from "../screens/Home"
/*INIT_IMPORT_SCREENS*/

import {

  INDEX_ROUTE,
  LOGIN_ROUTE,
  // PASSWORD_RECOVERY,
  RESTAURANTS_ROUTE,
  RESTAURANTS_ADD_ROUTE,
  RESTAURANTS_EDIT_ROUTE,
  RESTAURANTS_COPY_ROUTE,
  RESTAURANTS_STATISTICS_ROUTE,
  STATISTICS_RRPP_ROUTE,
  MENU_CATEGORY_ROUTE,
  MENU_CATEGORY_ADD_ROUTE,
  MENU_CATEGORY_EDIT_ROUTE,
  TICKET_TYPES_ROUTE,
  TICKET_TYPE_ADD_ROUTE,
  TICKET_TYPE_EDIT_ROUTE,
  TICKETS_ROUTE,
  TICKET_ADD_ROUTE,
  TICKET_EDIT_ROUTE,
  USERS_ROUTE,
  DELIVERYS_ROUTE,
  PLACES_ADD_ROUTE,
  PLACES_EDIT_ROUTE,
  PLACES_ROUTE,
  NEWS_ROUTE,
  NEWS_ADD_ROUTE,
  NEWS_EDIT_ROUTE,
  NOTIFICATIONS_ROUTE,
  NOTIFICATIONS_ADD_ROUTE,
  NOTIFICATIONS_EDIT_ROUTE,
  RESERVATIONS_ROUTE,
  DDJJ_ROUTE,
  UNAUTHORIZED_ROUTE
  
} from "./RoutesConstants";

const Routes = () => {
  return (
    <Switch>
      <Route path={LOGIN_ROUTE}>
        <Login/>
      </Route>
      <Route path={MENU_CATEGORY_ADD_ROUTE}>
        <AddEditMenuCategory isEditing={false}/>
      </Route>
      <Route path={MENU_CATEGORY_EDIT_ROUTE}>
        <AddEditMenuCategory isEditing={true}/>
      </Route>
      <Route path={MENU_CATEGORY_ROUTE}>
        <MenuCategories/>
      </Route>
      <Route path={TICKET_TYPE_ADD_ROUTE}>
        <AddEditTicketType isEditing={false}/>
      </Route>
      <Route path={TICKET_TYPE_EDIT_ROUTE}>
        <AddEditTicketType isEditing={true}/>
      </Route>
      <Route path={TICKET_TYPES_ROUTE}>
        <TicketTypes/>
      </Route>
      <Route path={TICKET_ADD_ROUTE}>
        <AddEditTicket isEditing={false}/>
      </Route>
      <Route path={TICKET_EDIT_ROUTE}>
        <AddEditTicket isEditing={true}/>
      </Route>
      <Route path={TICKETS_ROUTE}>
        <Tickets/>
      </Route>
      <Route path={RESERVATIONS_ROUTE}>
        <Reservations/>
      </Route>
      <Route path={RESTAURANTS_ADD_ROUTE}>
        <AddEditRestaurant isEditing={false}/>
      </Route>
      <Route path={RESTAURANTS_EDIT_ROUTE}>
        <AddEditRestaurant isEditing={true}/>
      </Route>
      <Route path={RESTAURANTS_COPY_ROUTE}>
        <AddEditRestaurant isCopy={true}/>
      </Route>
      <Route path={STATISTICS_RRPP_ROUTE}>
        <StatisticsRRPP/>
      </Route>
      <Route path={RESTAURANTS_STATISTICS_ROUTE}>
        <Statistics/>
      </Route>
      <Route path={RESTAURANTS_ROUTE}>
        <Restaurants/>
      </Route>
      <Route path={USERS_ROUTE}>
        <Users/>
      </Route>
      <Route path={DELIVERYS_ROUTE}>
        <DeliveryBoys/>
      </Route>
      <Route path={DDJJ_ROUTE}>
        <DDJJ/>
      </Route>
      <Route path={PLACES_ROUTE}>
        <Places/>
      </Route>
      <Route path={UNAUTHORIZED_ROUTE}>
        <h1>Desautorizado</h1>
      </Route>
      <Route path={NOTIFICATIONS_ADD_ROUTE}>
        <AddEditNotifications/>
      </Route>
      <Route path={NOTIFICATIONS_EDIT_ROUTE}>
        <AddEditNotifications isEditing={true}/>
      </Route>
      <Route path={NOTIFICATIONS_ROUTE}>
        <Notifications/>
      </Route> 
      <Route path={NEWS_ADD_ROUTE}>
        <AddEditNovelty/>
      </Route>
      <Route path={NEWS_EDIT_ROUTE}>
        <AddEditNovelty isEditing={true}/>
      </Route>
      <Route path={NEWS_ROUTE}>
        <News/>
      </Route> 
      {/* <Route path={PASSWORD_RECOVERY}>
        <PasswordRecovery/>
      </Route> */}
      <Route path={INDEX_ROUTE}>
      {/* Reemplazar por un Home cuando tengamos uno definido */}
        <Home/>
      </Route>
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/config/Routes.js